module.exports = __webpack_public_path__ + "/images/shop/footer-reduced/norton_security.jpg";